import React from 'react';
import { useSelector } from 'react-redux';
import { getDateFormat, getTimezone } from '../../redux/selectors/userData';
import { dateFormatter, formatStandardDateStrings, fromTimestamp } from '../../helpers/formatTime';
interface FlightListDateDividerProps {
  timestamp: number;
}

const FlightListDateDivider: React.FC<FlightListDateDividerProps> = ({ timestamp }) => {
  const dateFormat = useSelector(getDateFormat);
  const timezone = useSelector(getTimezone);
  const localMoment = fromTimestamp(timestamp);
  const localMomentInTimezone = fromTimestamp(timestamp).tz(timezone);
  const isToday = localMomentInTimezone.isSame(new Date(), 'day');
  const isYesterday = localMomentInTimezone.isSame(new Date(Date.now() - 86400000), 'day');
  let dateString: string = '';
  if (isToday) {
    dateString = 'TODAY';
  } else if (isYesterday) {
    dateString = 'YESTERDAY';
  } else {
    const dateFormatFn = dateFormatter(dateFormat);
    [dateString] = formatStandardDateStrings(dateFormatFn, localMoment, timezone);
  }

  return <div className="flight-detail-list-item-date-divider">{dateString}</div>;
};

export default FlightListDateDivider;
